import { render, staticRenderFns } from "./ViewBusinessPermits.vue?vue&type=template&id=5183e02e"
import script from "./ViewBusinessPermits.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBusinessPermits.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports